import storage from "../../../utils/store/storage";
import { SINGLE_SIGN_ON_RESPONSE } from "../../../utils/store/storeVariables";
import { SingleSignOnResponse } from "../dataTypes";

export function saveSingleSignOnResponse(singleSignOnResponse?: SingleSignOnResponse, rememberMe?: boolean) {
  storage.saveItem(SINGLE_SIGN_ON_RESPONSE, rememberMe ?? false, singleSignOnResponse);
}
